export default __webpack_public_path__ + "static/media/noPayment.828bcd04.png";